export default __webpack_public_path__ + "static/media/kubion.1ccdc7b5.png";